import { render, staticRenderFns } from "./startupNameCard.vue?vue&type=template&id=2119975b&scoped=true&"
import script from "./startupNameCard.vue?vue&type=script&lang=js&"
export * from "./startupNameCard.vue?vue&type=script&lang=js&"
import style0 from "./startupNameCard.vue?vue&type=style&index=0&id=2119975b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119975b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2119975b')) {
      api.createRecord('2119975b', component.options)
    } else {
      api.reload('2119975b', component.options)
    }
    module.hot.accept("./startupNameCard.vue?vue&type=template&id=2119975b&scoped=true&", function () {
      api.rerender('2119975b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/startupProfile/startupNameCard.vue"
export default component.exports